import * as React from "react";
import Table from "antd/lib/table";
import Row from "antd/lib/row";
import { useSelector, useDispatch } from "react-redux";
import { ProviderAdvancedSearchForm } from './epicprosearchform';
import Dropdown from 'antd/lib/dropdown';
import Menu from 'antd/lib/menu';
import Button from 'antd/lib/button';
import { useCtx } from "one-ui-provider";
import Layout from "antd/lib/layout";
const { Content } = Layout;
import {
    setSpin,
    SEARCH
} from 'one-state-provider-global-search';
import Skeleton from 'antd/lib/skeleton';

export const EpicProviderSearchTab = (props: any) => {
    const {
        modelvalue,
        preferred_name
    } = props;

    const {
        providermodel,
        onProviderRowClick,
    } = modelvalue;
    const { log,settings } = useCtx();
    const {compatible} = settings;
    const { contact_center_type } = compatible;
    let providermodaldata: any = [];
    const dispatch = useDispatch();
    const { active, actions } = useSelector((state: any) => (
        state.hotkeys
    ));
    const disabled = (!((active) && (actions)));

    const transfer = (transferactions: any, target: any) => {
        if (transferactions) {
            transferactions.transfer(target)
                .catch((e: any) => {
                    log.error(
                        "one-comp-patient-global-search",
                        "provider-search-table-transfer", {
                        e
                    }
                    );
                    alert(e.message)
                });
        }
    }

    const consult = (consultactions: any, target: any) => {
        if (consultactions) {
            consultactions.consult(target)
                .catch((event: any) => {
                    log.error(
                        "one-comp-patient-global-search",
                        "provider-search-table-consult", {
                        event
                    }
                    );
                    alert(event.message)
                });
        }
    }


    const sources = providermodel?.data;
    sources.forEach((providerdata: any) => {
        let selectedpName=(providerdata?.preferredName?' "'+providerdata?.preferredName+'"':'')
        const info = {
            name: providerdata?.firstname ? (providerdata?.firstname +(preferred_name&&selectedpName)) : "",
            dept: providerdata.department ? providerdata.department : "",
            location: providerdata.location ? providerdata.location : "",
            address: providerdata.address ? providerdata.address : "",
            phone: providerdata.contact ? providerdata.contact : "",
            id: providerdata.id ? providerdata.id : ""
        }
        providermodaldata.push(info);
    })

    let dispatchMethod = async (params: any) => {
        dispatch({
            type: SEARCH,
            payload: {
                name: params.proglobalname,
                dept: params.proglobaldepartment,
                location: params.progloballocation,
                phone: params.proglobalnumber
            }
        });
        dispatch(
            setSpin(true)
        ); 
    }
    const handleMenuClick = (e: any) => {
        let key = e.key;
        let res = key.split(",");
        if (res[1] === '1') {
            onProviderRowClick(res[0])
        } else if (res[1] === '2') {
            if (actions && res[0]) {
                consult(actions, res[0].replace(/[_-]/g, ""));
            }
        } else if (res[1] === '3') {
            if (actions && res[0]) {
                transfer(actions, res[0].replace(/[_-]/g, ""));
            }
        }
    }

    /**
     * This fuction is used to create Menu.
     * @param e record id
     */
    const menu = (e: any) => (
        <Menu onClick={handleMenuClick}>
            <Menu.Item key={e.id + ",1"}>Select as Caller</Menu.Item>
            <Menu.Item key={e.phone + ",2"} disabled={disabled}>Consult</Menu.Item>
            <Menu.Item key={e.phone + ",3"} disabled={disabled}>Transfer</Menu.Item>
        </Menu>
    );

    const columns = [
        {
            title: "Name",
            dataIndex: "name",
            key: "name"
        },
        {
            title: "Department",
            dataIndex: "dept",
            key: "dept"
        },
        {
            title: "Location",
            dataIndex: "location",
            key: "location",
            width: 250,
        },
        {
            title: "Address",
            dataIndex: "address",
            key: "address",
            ellipsis:true
        },
        {
            title: "PhoneNumber",
            dataIndex: "phone",
            key: "phone"
        },
        {
            title: "Action",
            key: "action",
            render: (text: any, record: any) => (
                <Dropdown overlay={menu(record)}>
                    <Button type="link" size="small" className="ant-btn-link--dark">&hellip;</Button>
                </Dropdown>
            )
        }

    ];

    return (
        <Layout >
            <Content>
                <section className={(contact_center_type === "genesys" || contact_center_type === 'twilio' ) ? 'providerglobalsearchheader' :'globalsearchcontainer'}>
                    <header className='globalsearchheader'>
                        <Row>
                            <ProviderAdvancedSearchForm dispatchMethod={dispatchMethod} />
                        </Row>
                    </header>
                    <div className="global-search-skeleton">
                    <Skeleton active loading={providermodel?.spin} paragraph={{ rows: 3 }}>
                        <Table
                            columns={columns}
                            dataSource={providermodaldata}
                            pagination={{ pageSize: 5 }}
                        />
                    </Skeleton>
                    </div>
                </section>
            </Content>
        </Layout>
    );
};